export const CLEAR_STATE = 'CLEAR_STATE';
